var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Company } from 'packages/company/entities/Company';
import ENV from 'config/env';
import { Candidate } from 'packages/v3/jobs/Candidate';
import { Job } from 'packages/v3/jobs/Job';
import { EntityBuilder } from '@/node_modules/@decahedron/entity';
var CompanyRepository = /** @class */ (function (_super) {
    __extends(CompanyRepository, _super);
    function CompanyRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_ROOT + "v3/";
        _this.url = 'companies';
        _this.entity = Company;
        return _this;
    }
    CompanyRepository.prototype.getNewCandidatesForCompany = function (companyId) {
        var _this = this;
        return this.get(this.url + "/" + companyId + "/candidates").then((function (response) {
            response.data.data.forEach(function (object) {
                object.job = EntityBuilder.buildOne(Job, __assign(__assign({}, object.job), { location: object.job.city }));
                object.candidate = EntityBuilder.buildOne(Candidate, __assign(__assign({}, object.talent), { jobId: object.job.id, talent: object.talent }));
                delete (object.talent);
            });
            return (_this.responseTransformer(response.data));
        }));
    };
    return CompanyRepository;
}(AbstractRepository));
export { CompanyRepository };
